'use client'
import React, { FormEvent, useEffect, useState } from 'react'
import PaymentWrapper from 'ui/components/PaymentWrapper'
import { useCart } from 'medusa-react'
import { useStore } from '@lib/context/store-context'
import LoadingIcon from 'ui/icons/LoadingIcon'
import CheckoutForm, { checkoutValidationSchema } from 'ui/components/CheckoutForm'
import OrderOverview from 'ui/components/OrderOverview'
import { Cart } from '@medusajs/medusa'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import PaymentElements from 'ui/components/PaymentElements'
import routes from '@lib/routes'
import { useRouter } from 'next/navigation'
import Message from 'ui/components/Message'
import classNames from 'classnames'

const Checkout = () => {
    const { cart } = useCart()
    const { initPayment } = useStore()
    const methods = useForm({
        mode: 'onBlur',
        resolver: yupResolver(checkoutValidationSchema),
    })
    const router = useRouter()

    const [paymentFailed, setPaymentFailed] = useState(false)

    useEffect(() => {
        if (location?.href.includes('betaling-mislukt')) {
            setPaymentFailed(true)
        }
    }, [])

    useEffect(() => {
        if (!cart || (cart?.id && cart?.items?.length < 1)) {
            router.push(routes.shoppingCart)
        }
    }, [cart])

    useEffect(() => {
        if (cart && !cart?.payment_session) {
            initPayment()
        }
    }, [cart?.payment_session])

    return (
        <FormProvider {...methods}>
            <form className="container py-16" onSubmit={(event: FormEvent) => event.preventDefault()}>
                <div
                    className={classNames('mb-8', {
                        block: paymentFailed,
                        hidden: !paymentFailed,
                    })}
                >
                    <Message color={'red'}>
                        <div className="flex flex-col gap-y-2">
                            <p className="font-medium">Betaling mislukt</p>
                            <p>
                                Er is iets misgegaan bij de betaling, er is geen geld afgeschreven. Probeer het opnieuw.
                            </p>
                        </div>
                    </Message>
                </div>
                <div className="flex flex-col justify-between gap-6 xl:gap-16 lg:flex-row">
                    <div className="lg:w-1/2 lg:max-w-1/2">
                        <h1 className="pb-4 text-2xl">Gegevens</h1>
                        <h2 className="pb-4 text-xl font-medium">Uw gegevens</h2>
                        <CheckoutForm cart={cart as unknown as Cart} />
                    </div>
                    <div className="lg:w-1/2 lg:max-w-1/2">
                        <h1 className="pb-2 text-2xl">Bestelling</h1>
                        <OrderOverview cartOrOrder={cart as unknown as Cart} />
                        <div className="bg-brand-grey050 px-4 pb-4">
                            {cart?.payment_session ? (
                                <PaymentWrapper paymentSession={cart.payment_session}>
                                    <PaymentElements cart={cart as unknown as Cart} />
                                </PaymentWrapper>
                            ) : (
                                <LoadingIcon />
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </FormProvider>
    )
}

export default Checkout
